import { useCallback, useMemo } from 'react';
import {
	ToothPathology,
	ToothPathologyDiscolorationValues,
	ToothSurface,
} from '../../../../../graphql/graphql';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { handleSurfacesOperation } from '../../../Helpers/surfaces/toothSurfaces.helper';

export default function useToothPathologyDiscoloration({
	pathology,
	setPathology,
}: {
	pathology?: ToothPathology;
	setPathology: (pathology: ToothPathology) => void;
}) {
	const setSurfaces = useCallback(
		(surfaces: ToothSurface[], operation: SurfaceOperation) => {
			setPathology({
				...pathology,
				discoloration: {
					...pathology?.discoloration,
					values: pathology?.discoloration?.values ?? {},
					surfaces: handleSurfacesOperation(
						pathology?.discoloration?.surfaces ?? [],
						surfaces,
						operation,
					),
				},
			});
		},
		[pathology, setPathology],
	);

	const setValues = useCallback(
		(values: ToothPathologyDiscolorationValues) => {
			setPathology({
				...pathology,
				discoloration: {
					...pathology?.discoloration,
					surfaces: pathology?.discoloration?.surfaces ?? [],
					values,
				},
			});
		},
		[pathology, setPathology],
	);

	return useMemo(
		() => ({
			discoloration: {
				surfaces: pathology?.discoloration?.surfaces ?? [],
				setSurfaces: setSurfaces,
				values: pathology?.discoloration?.values,
				setValues: setValues,
			},
		}),
		[pathology],
	);
}
